<template>
  <div class="wt-media-filtering-manuel-tags wt2-sg">
    <transition name="-transition-height">
      <div class="-content" v-if="showTags && tagsAvailable">
        <div class="-caption">
          <span class="wt2-text-n2 wt2-color-normal">Buzz:</span>
        </div>
        <ul>
          <manuel-tag
            v-for="(tag, index) in normalizeTags"
            :key="index"
            :disabled="selectedTag === tag.phrase"
            @select="$emit('select', tag)"
            :tag="tag"
          />
        </ul>
        <wt-button
          type="transparent"
          class="-hide -custom -smaller-font -min-width-unset -remove-hover-background"
          text="Hide"
          @click="$emit('hide')"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import app from 'app';

const ManuelTag = app.Vue.extend({
  // language=Vue
  template: `
<li class="-manuel-tag">
       <span v-if="tag.phrase === '.'">{{tag.friendlyName}}</span> 
       <wt-button v-else
         type="transparent"
         class="-btn 
            -custom 
            -smaller-font 
            -min-width-unset 
            -remove-hover-background"
         :text="tag.friendlyName"
         :icon="tag.icon"
         :disabled="disabled"
         @click="$emit('select', tag)"
       />
</li>`.normalizeSpace(),
  name: 'manuel-tag',
  props: {
    tag: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});

export default {
  data() {
    return {
      tags: null,
    };
  },

  name: 'wt-media-filtering-manual-tags',

  components: {
    ManuelTag,
  },

  props: {
    selectedTag: {
      type: String,
      default: '',
    },

    showTags: {
      type: Boolean,
      default: false,
    },

    isContentMarketing: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    app.api.searchRecommendations
      .get()
      .done((response) => {
        this.tags = response;
        if (this.isContentMarketing) {
          this.tags = _.filter(this.tags, (tag) => {
            return tag.phrase !== '.' && tag.phrase !== 'Viral';
          });
        }
        if (this.tagsDisabled) {
          this.$emit('tags-disabled');
        }
      })
      .fail((e) => {
        this.$emit('tags-disabled');
        app.doctorController.report(
          '_showManualTags: get searchRecommendations failed',
          e
        );
      });
  },

  computed: {
    tagsDisabled() {
      return this.tags && !this.tags.length;
    },

    tagsAvailable() {
      return this.tags && this.tags.length;
    },

    normalizeTags() {
      return _.map(this.tags, (tag) => {
        if (tag && tag.phrase) {
          tag.phrase = _.trim(tag.phrase);
        }
        if (tag && tag.friendlyName) {
          tag.friendlyName = _.trim(tag.friendlyName);
        }
        return tag;
      });
    },
  },
};
</script>
